// Preprod pick: Issue 88: normalize Bangladesh RMN digits when user pastes phone number.
export const normalizeBangladeshRmn = (value = '') => {
  const digits = `${value}`.replace(/\D/g, '');

  if (!digits) return '';

  if (digits.startsWith('880') && digits.length > 3) {
    const withoutCountryCode = digits.slice(3);
    if (!withoutCountryCode) return '';
    return withoutCountryCode.startsWith('0')
      ? withoutCountryCode.slice(0, 11)
      : `0${withoutCountryCode}`.slice(0, 11);
  }

  if (digits.startsWith('0')) {
    return digits.slice(0, 11);
  }

  if (digits.startsWith('1') && digits.length >= 10) {
    return `0${digits}`.slice(0, 11);
  }

  return digits.slice(0, 10);
};
